import ClictopayPaymentForm, {
    type ClictopayLinkProcessorConfig,
} from "@/modules/billing/clictopay/ClictopayPaymentForm.tsx";
import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";

export function makeClictopayLink(config: ClictopayLinkProcessorConfig) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            PaymentForm: (props) => <ClictopayPaymentForm {...props} method={method} config={config} />,
        };
    });
}
